var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from "vue-property-decorator";
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeIndex = "1";
        _this.company = {
            qrcode: require("../../static/other/公众号二维码.jpg"),
        };
        _this.scroll = 0;
        _this.timer = null;
        _this.seen = true;
        _this.currentMenu = "首页";
        _this.showFastBtn = false;
        return _this;
    }
    // methods: {
    Layout.prototype.handleSelect = function (key) {
        switch (key) {
            case "1":
                this.$router.push({ name: "Index" });
                break;
            case "2":
                window.location.hash = "#解决方案";
                break;
            case "3":
                window.location.hash = "#合作院校";
                break;
            case "4":
                window.location.hash = "#关于我们";
                break;
        }
        this.activeIndex = key;
    };
    Layout.prototype.handleSelectMobile = function (key) {
        switch (key) {
            case "1":
                this.$router.push({ name: "Index" });
                this.currentMenu = "首页";
                break;
            case "2-1":
                window.location.hash = "#解决方案";
                this.currentMenu = "解决方案";
                break;
            // case "3":
            //   (this as any).$router.push({ name: "Index" });
            //   window.location.hash = "#产品特点";
            //   this.currentMenu = "产品特点";
            //   break;
            case "4":
                window.location.hash = "#合作院校";
                this.currentMenu = "合作院校";
                break;
            case "5":
                window.location.hash = "#关于我们";
                this.currentMenu = "关于我们";
                break;
        }
        this.activeIndex = key;
    };
    Layout.prototype.handleScroll = function () {
        this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
        if (this.scroll > 600) {
            //判断滚动后高度超过400px,就显示
            this.showFastBtn = true;
        }
        else {
            this.showFastBtn = false;
        }
    };
    Layout.prototype.backTop = function () {
        var _this = this;
        //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
        this.timer = setInterval(function () {
            var osTop = document.documentElement.scrollTop || document.body.scrollTop;
            var ispeed = Math.floor(-osTop / 5);
            document.documentElement.scrollTop = document.body.scrollTop =
                osTop + ispeed;
            if (osTop === 0) {
                clearInterval(_this.timer);
            }
            // (this as any).$router.push({ name: "Index" });
            _this.currentMenu = "首页";
            _this.activeIndex = '1';
        }, 30);
    };
    Layout.prototype.menuSeen = function () {
        // 屏幕尺寸
        var screenHeight = document.body.clientWidth;
        if (screenHeight > 415) {
            this.seen = true;
        }
        else {
            this.seen = false;
        }
    };
    Layout.prototype.logoClick = function () {
        this.$router.push({ name: "Index" });
        this.currentMenu = "首页";
    };
    // },
    Layout.prototype.mounted = function () {
        this.menuSeen();
        window.addEventListener("scroll", this.handleScroll);
    };
    Layout = __decorate([
        Component
    ], Layout);
    return Layout;
}(Vue));
export default Layout;
